/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_CsvInputs */

const en_export_csv = /** @type {(inputs: Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export CSV`)
};

const es_export_csv = /** @type {(inputs: Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar CSV`)
};

const fr_export_csv = /** @type {(inputs: Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter en CSV`)
};

const de_export_csv = /** @type {(inputs: Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV exportieren`)
};

const id_export_csv = /** @type {(inputs: Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekspor CSV`)
};

/** @type {(inputs: Export_CsvInputs) => LocalizedString} */
const ja_export_csv = en_export_csv;

/** @type {(inputs: Export_CsvInputs) => LocalizedString} */
const zh_export_csv = en_export_csv;

/** @type {(inputs: Export_CsvInputs) => LocalizedString} */
const ar_export_csv = en_export_csv;

/** @type {(inputs: Export_CsvInputs) => LocalizedString} */
const it_export_csv = en_export_csv;

/** @type {(inputs: Export_CsvInputs) => LocalizedString} */
const ru_export_csv = en_export_csv;

/** @type {(inputs: Export_CsvInputs) => LocalizedString} */
const pt_export_csv = en_export_csv;

/** @type {(inputs: Export_CsvInputs) => LocalizedString} */
const ko_export_csv = en_export_csv;

/**
* | output |
* | --- |
* | "Export CSV" |
*
* @param {Export_CsvInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const export_csv = /** @type {((inputs?: Export_CsvInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_CsvInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_export_csv(inputs)
	if (locale === "es") return es_export_csv(inputs)
	if (locale === "fr") return fr_export_csv(inputs)
	if (locale === "de") return de_export_csv(inputs)
	if (locale === "ja") return ja_export_csv(inputs)
	if (locale === "zh") return zh_export_csv(inputs)
	if (locale === "ar") return ar_export_csv(inputs)
	if (locale === "id") return id_export_csv(inputs)
	if (locale === "it") return it_export_csv(inputs)
	if (locale === "ru") return ru_export_csv(inputs)
	if (locale === "pt") return pt_export_csv(inputs)
	return ko_export_csv(inputs)
});